import React from 'react';
import OfferingHandler from '../OfferingListView/OfferingHandler';
import { RouteProps, RouteComponentProps } from 'react-router-dom';
import DetailsMode from 'Core/models/DetailsMode';
import NotificationService from 'Core/NotificationService';
import { OfferingType, OfferingViewModel, Operations } from 'Core/Api/Api';
import {
    PageHeader,
    Row,
    Col,
    Descriptions,
    Skeleton,
    Card,
    Button,
    Divider,
    Typography,
    Icon,
} from 'antd';
import sanitizeHtml from 'sanitize-html';
import renderHTML from 'react-render-html';
import Utility from 'Core/Utility';
import moment from 'moment';
import { withRouter } from 'react-router';
import ConfigService from 'Core/ConfigService';
import Config from '../../../Core/Config.json';
import {
    SharepoolDetailsTable as SharePoolDetailsTable,
    IPOTitle,
    IPOImage,
    BorderlessDescriptions,
    ProspectusLink,
    GeneralApplyNowLink,
} from '.';
import { CenterAlignedRow } from 'components/Styled/Layout/CenterAlignedRow';
import { LeftAlignedRow } from 'components/Styled/Layout/LeftAlignedRow';
import {
    FullWithButton,
    VMFullWithButton,
    WhiteBackgroundCard,
} from 'components/Forms/Form.Styled';
import ShowIfHavePermission from 'components/Forms/ShowIfHavePermission';
import DetailsData from 'Core/models/DetailsData';
import IfNotLoggedInModal from 'components/Forms/IfNotLoggedInModal';
import AuthContext from '../../../Context/AuthContext';
import { startCase } from 'lodash';
import NumberFormat from 'react-number-format';

export interface Props extends RouteComponentProps {
    children?: React.ReactNode;
}

export interface State {
    offering?: OfferingViewModel;
}

export class OfferingDetailsViewWithoutRouter extends React.Component<Props, State> {
    handler: OfferingHandler;
    config: typeof Config;
    static contextType = AuthContext;
    context!: React.ContextType<typeof AuthContext>;

    constructor(props: Props) {
        super(props);

        this.state = {};
        this.handler = new OfferingHandler(props);
        this.config = ConfigService.getSync();
    }

    DownloadLink(fileUrl: string | undefined): void {
        Utility.downloadURI(fileUrl, '');
    }

    generalApplyClicked = () => {
        if (this.context.data) {
            this.props.history.push(
                `/ipo/apply/${this.state.offering?.id}`,
                new DetailsData(DetailsMode.New, this.state.offering?.id)
            );
        } else {
        }
    };

    componentDidMount() {
        const urlState = this.props.match.params as { id: string } | undefined;

        if (urlState) {
            this.handler.GetOfferingViewModelById({ id: urlState.id }).then(
                x => {
                    this.setState({ offering: x.offering });
                },
                x => NotificationService.error(x.message)
            );
        }
    }

    render() {
        return (
            <Row type="flex" justify="center">
                <Col span={24}>
                    <WhiteBackgroundCard>
                        <Skeleton active loading={!this.state.offering}>
                            <CenterAlignedRow>
                                <Col span={24}>
                                    <LeftAlignedRow>
                                        <Col>
                                            <IPOTitle>{this.state.offering?.title}</IPOTitle>
                                        </Col>
                                    </LeftAlignedRow>
                                    <Row type="flex">
                                        <Col xs={24} sm={7} style={{ marginBottom: '10px' }}>
                                            <LeftAlignedRow>
                                                <Col>
                                                    <Row>
                                                        <Col xs={24} style={{ textAlign: 'center' }}>
                                                            <IPOImage src={this.state.offering?.logo?.fileUrl} />
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <Divider />
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <BorderlessDescriptions column={2}>
                                                                <Descriptions.Item span={2} label="Short Name">
                                                                    <div style={{ fontWeight: 'bolder' }}>
                                                                        {this.state.offering?.shortName}
                                                                    </div>
                                                                </Descriptions.Item>
                                                                <Descriptions.Item span={2} label="Arranger">
                                                                    <div style={{ fontWeight: 'bolder' }}>
                                                                        {this.state.offering?.arrangerName}
                                                                    </div>
                                                                </Descriptions.Item>
                                                                <Descriptions.Item span={2} label="Lead Broker">
                                                                    <div style={{ fontWeight: 'bolder' }}>
                                                                        {this.state.offering?.leadBrokerName}
                                                                    </div>
                                                                </Descriptions.Item>
                                                                {(this.state.offering?.coBrokersNames?.length ?? 0) > 0 ?
                                                                    <>
                                                                        <Descriptions.Item className="flexed" span={2} label="Co Brokers">
                                                                            {''}
                                                                        </Descriptions.Item>
                                                                        <Descriptions.Item>
                                                                            <div style={{ fontWeight: 'bolder' }}>
                                                                                {this.state.offering?.coBrokersNames?.map(x => (
                                                                                    <>
                                                                                        <span> {x} </span>
                                                                                        <br />
                                                                                    </>
                                                                                ))}
                                                                            </div>
                                                                        </Descriptions.Item>
                                                                    </>
                                                                    : ''
                                                                }
                                                            </BorderlessDescriptions>
                                                            <BorderlessDescriptions column={1}>
                                                                <Descriptions.Item label="Currency">
                                                                    <div style={{ fontWeight: 'bolder' }}>
                                                                        {this.state.offering?.currency}
                                                                    </div>
                                                                </Descriptions.Item>
                                                                <Descriptions.Item label="Minimum Quantity">
                                                                    <div style={{ fontWeight: 'bolder' }}>
                                                                        <NumberFormat
                                                                            value={this.state.offering?.minimumQuantityValue}
                                                                            displayType={'text'}
                                                                            thousandSeparator={true}
                                                                            decimalScale={0}
                                                                            fixedDecimalScale={true}
                                                                        />
                                                                    </div>
                                                                </Descriptions.Item>
                                                                <Descriptions.Item label="Share Increments">
                                                                    <div style={{ fontWeight: 'bolder' }}>
                                                                        <NumberFormat
                                                                            value={this.state.offering?.shareIncrements}
                                                                            displayType={'text'}
                                                                            thousandSeparator={true}
                                                                            decimalScale={0}
                                                                            fixedDecimalScale={true}
                                                                        />
                                                                    </div>
                                                                </Descriptions.Item>

                                                                <Descriptions.Item label="Open Date">
                                                                    <div style={{ fontWeight: 'bolder' }}>
                                                                        <Typography.Text underline={true}>
                                                                            {Utility.renderDateWithReference(
                                                                                moment(this.state.offering?.openingDate),
                                                                                this.config.Display.DateFormat
                                                                            )}
                                                                        </Typography.Text>
                                                                    </div>
                                                                </Descriptions.Item>
                                                                <Descriptions.Item label="Closing Date">
                                                                    <div style={{ fontWeight: 'bolder' }}>
                                                                        <Typography.Text underline={true}>
                                                                            {Utility.renderDateWithReference(
                                                                                moment(this.state.offering?.closingDate),
                                                                                this.config.Display.DateFormat
                                                                            )}
                                                                        </Typography.Text>
                                                                    </div>
                                                                </Descriptions.Item>
                                                                <Descriptions.Item label="Status">
                                                                    <div style={{ fontWeight: 'bolder' }}>
                                                                        <Typography.Text underline={true}>
                                                                            {startCase(this.state.offering?.status)}
                                                                        </Typography.Text>
                                                                    </div>
                                                                </Descriptions.Item>
                                                            </BorderlessDescriptions>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <Row>
                                                                <Col>
                                                                    <ProspectusLink
                                                                        type="link"
                                                                        onClick={x =>
                                                                            this.DownloadLink(this.state.offering?.prospectus?.fileUrl)
                                                                        }>
                                                                        {this.state.offering?.offeringType == OfferingType.PreferenceShares ? 'View Offer Details' : 'View Prospectus'}
                                                                        <Icon type="down-square" />
                                                                    </ProspectusLink>
                                                                </Col>
                                                            </Row>


                                                        </Col>
                                                    </Row>
                                                </Col>
                                            </LeftAlignedRow>
                                        </Col>
                                        <Col xs={24} sm={{ span: 16, offset: 1 }}>
                                            <LeftAlignedRow>
                                                <Col>
                                                    <Row>

                                                        <Col>

                                                            <Typography.Title style={{ fontWeight: 'bolder', color: 'black' }} level={4} type="secondary">
                                                                Summary
                                                            </Typography.Title>

                                                        </Col>

                                                    </Row>
                                                    <Row>

                                                        <Col>{renderHTML(this.state.offering?.summary ?? '<div></div>')}</Col>

                                                    </Row>
                                                    <Row>
                                                        <Col xs={24}>
                                                            <div style={{ overflowX: 'auto' }}>
                                                                <SharePoolDetailsTable
                                                                    sharePool={this.state.offering?.sharePools}
                                                                    currency={this.state.offering?.currency}
                                                                    offering={this.state.offering}
                                                                    offeringStatus={this.state.offering?.status} {...this.props}  ></SharePoolDetailsTable>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            </LeftAlignedRow>
                                        </Col>
                                    </Row>
                                </Col>
                            </CenterAlignedRow>
                        </Skeleton>
                    </WhiteBackgroundCard>
                </Col>
            </Row>
        );
    }
}

const OfferingDetailsView = withRouter(OfferingDetailsViewWithoutRouter);

export default OfferingDetailsView;
